import React from 'react'
import { connect } from 'react-redux'

const TimeZoneConvert = (props) => <></>

const mapStateToProps = state => ({
  loading: state.loading,
  headerHide: state.headerHide,
  timeZoneId: state.timeZoneId,
});

export default connect(mapStateToProps, null)(TimeZoneConvert);
